import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useCounts } from "../context/CountsContext";
import { useEffect } from "react";
import {
  SidebarContainer,
  SidebarList,
  SidebarItem,
  SidebarButton,
  ToggleButton,
  CountBadge,
} from "../styles/SidebarStyles";
import {
  LayoutDashboard,
  Store,
  Bike,
  ShoppingBag,
  Settings,
  DollarSign,
  LogOut,
  Inbox,
  UserPlus,
  Bell,
  AlertCircle,
} from "lucide-react";

const itemVariants = {
  hidden: { opacity: 0, x: -30 },
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transition: { delay: i * 0.1, duration: 0.3 },
  }),
  hover: { scale: 1.05, transition: { duration: 0.2 } },
};

// Export menuItems for use in Header.js
export const menuItems = [
  { label: "Dashboard", path: "/dashboard", icon: <LayoutDashboard size={30} /> },
  { label: "Vendors", path: "/vendors", icon: <Store size={30} /> },
  { label: "Riders", path: "/riders", icon: <Bike size={30} /> },
  { label: "Orders", path: "/orders", icon: <ShoppingBag size={30} /> },
  { label: "Inbox", path: "/inbox", icon: <Inbox size={30} /> },
  { label: "Requests", path: "/vendor-requests", icon: <UserPlus size={30} /> },
  { label: "Notifications", path: "/notifications", icon: <Bell size={30} /> },
  { label: "Complaints", path: "/complaints", icon: <AlertCircle size={30} /> },
  { label: "Settings", path: "/settings", icon: <Settings size={30} /> },
  { label: "Finance", path: "/finance", icon: <DollarSign size={30} /> },
  { label: "Logout", path: "/", icon: <LogOut size={30} /> },
];

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen, onMenuItems }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const counts = useCounts();

  // Update menuItems with counts for display
  const updatedMenuItems = menuItems.map((item) => ({
    ...item,
    count:
      item.label === "Inbox"
        ? counts.inbox
        : item.label === "Vendor Requests"
        ? counts.vendorRequests
        : item.label === "Notifications"
        ? counts.notifications
        : item.label === "Complaints"
        ? counts.complaints
        : 0,
    action: item.label === "Logout" ? () => handleLogout() : null,
  }));

  // Pass menuItems to parent (Layout.js)
  useEffect(() => {
    if (onMenuItems) {
      onMenuItems(updatedMenuItems);
    }
  }, [counts, onMenuItems]);

  const handleLogout = () => {
    logout();
    navigate("/");
    setIsSidebarOpen(false);
  };

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <>
      <ToggleButton onClick={toggleSidebar}>{isSidebarOpen ? "Close" : "Menu"}</ToggleButton>
      <SidebarContainer isOpen={isSidebarOpen}>
        <SidebarList>
          {updatedMenuItems.map((item, index) => (
            <SidebarItem
              key={item.label}
              custom={index}
              initial="hidden"
              animate="visible"
              variants={itemVariants}
              whileHover="hover"
            >
              <SidebarButton
                onClick={() => {
                  item.action ? item.action() : navigate(item.path);
                  if (window.innerWidth <= 768) setIsSidebarOpen(false);
                }}
                variants={itemVariants}
              >
                {item.icon}
                {item.label}
                {item.count > 0 && <CountBadge>{item.count}</CountBadge>}
              </SidebarButton>
            </SidebarItem>
          ))}
        </SidebarList>
      </SidebarContainer>
    </>
  );
};

export default Sidebar;